module.exports = __webpack_public_path__ + "static/media/estudioDeTatuagemEPiercing.f101af23.jpg";